import axios from "axios";
import { userManager } from '@/auth/oidc';
import { customerForUser, selectedCustomer } from '@/utils/customerSelection';

const BASE = import.meta.env.VITE_API_BASE_URL;

const apiClient = axios.create({
  baseURL: BASE,
  headers: {
    "Content-Type": "application/json",
    "X-Client-Id": import.meta.env.VITE_CLIENT_ID,
  },
  withCredentials: true,
});

apiClient.interceptors.request.use(async config => {
  const selectionAtRequestStart = selectedCustomer.value;
  const user = await userManager.getUser();
  if (user && !user.expired) {
    config.headers.Authorization = `Bearer ${user.access_token}`;
    const customer = customerForUser(user.profile.sub, selectionAtRequestStart);
    if (customer) config.headers['X-Customer-Id'] = String(customer.customerId);
    else delete config.headers['X-Customer-Id'];
  } else {
    delete config.headers.Authorization;
    delete config.headers['X-Customer-Id'];
  }
  return config;
});

apiClient.interceptors.response.use(
  response => response,
  error => {
    const code = error.response?.data?.code;
    if (error.response?.status === 403 && [
      'trial_expired', 'subscription_past_due', 'subscription_cancelled', 'subscription_suspended',
    ].includes(code)) {
      window.dispatchEvent(new CustomEvent('ww-subscription-access-blocked', {
        detail: { code, message: error.response.data?.detail || error.response.data?.message || '' },
      }));
    }
    return Promise.reject(error);
  },
);

export default apiClient;
